module.exports = __webpack_public_path__ + "static/media/perso-healtheat.4f9d791f.png";